import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import {
  FormModeEnum,
  ToolbarItem,
  TableSettings,
  NotificationService,
  ModalService,
  BackendService,
  FieldStructure,
} from 'beyond-util';
import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { FormName } from '../../../enums/form-name.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { Subject } from 'rxjs/Subject';
import { ActionType } from '../../../enums/action-type.enum';
import { EnumService } from '../../../services/enum.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-odrzavanje-programa',
  templateUrl: './odrzavanje-programa.component.html',
})
export class OdrzavanjeProgramaComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;
  public showDetails = false;
  public mestoTroskaList: any[];
  public validateSubject: Subject<any> = new Subject();
  public validateSubject$ = this.validateSubject.asObservable();
  public actionType: ActionType;

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _enumService: EnumService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
      this._enumService.fetchVrsteMedija();
      this._enumService.fetchMestaTroska();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Novi program';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Program';
    }
  }

  validated(isValid: boolean) {
    if (isValid) {
      switch (this.actionType) {
        case ActionType.Create:
          this.createProgram();
          break;
        case ActionType.Update:
          this.updateProgram();
          break;
      }
    } else {
      this._notificationService.notyError('Niste uneli sva obavezna polja!');
    }
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSPRO_PRO,
          FormName.PregledProgama,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          this._spinner.hide();

          if (!this.settingsTable) {
            this.disableInlineActions(data.Settings);
            this.setSettings(data.Settings);
          }
          this._dataCount = data.ServiceData.DataSumCount;
          this._data = data.ServiceData.Data;
          this.setAllFields();
          this.refreshTable();
        })
    );
  }

  refreshTable() {
    this._data.forEach(d => (d.id = d.Id));
    this._data.forEach(d => (d.rbr = d.Id));

    this.orderListCount = this._dataCount;
    this.orderList = this._data;
  }

  addOrder() {
    this.actionType = ActionType.Create;
    this.validateSubject.next();
  }

  createProgram() {
    if (this.isValid()) {
      this._spinner.show();
      const payload = { ...this.order };
      payload.MestaTroska = this.orderListDetails.map(x => {
        return {
          Id: x.Naziv,
        };
      });
      this._subscriptions.push(
        this._rtsBackendService
          .save(FormCode.MSPRO_PRO, FormName.PregledProgama, payload)
          .subscribe(() => {
            this.changeMode(FormModeEnum.Table);
            this.loadSettings();
          })
      );
    }
  }

  isValid(): boolean {
    let retval = true;
    retval = retval && !this.hasDuplicateMestoTroska();

    if (this.hasDuplicateMestoTroska()) {
      this.notyMestoTroskaDuplikatError();
    }

    return retval;
  }

  hasDuplicateMestoTroska(): boolean {
    const checked = [];
    let retval = false;
    this.orderListDetails.forEach((i: { Naziv: number }) => {
      if (checked.find(x => x === i.Naziv)) {
        retval = true;
      } else {
        checked.push(i.Naziv);
      }
    });

    return retval;
  }

  updateProgram() {
    if (this.isValid()) {
      this._spinner.show();
      const payload = { ...this.order };
      payload.MestaTroska = this.orderListDetails.map(x => {
        return {
          Id: x.Naziv,
        };
      });

      this._subscriptions.push(
        this._rtsBackendService
          .update(FormCode.MSPRO_PRO, FormName.PregledProgama, payload)
          .subscribe(() => {
            this.changeMode(FormModeEnum.Table);
            this.loadSettings();
          })
      );
    }
  }

  updateOrder() {
    this.actionType = ActionType.Update;
    this.validateSubject.next();
  }

  onDeleteConfirm() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSPRO_PRO, FormName.PregledProgama, this.order.id)
        .subscribe(() => {
          this._notificationService.openNoty('Uspešno brisanje');
          this.changeMode(FormModeEnum.Table);
          this.loadSettings();
        })
    );
  }

  onTableActionView() {
    this.setToolbarOptions({
      items: [ToolbarItem.ItemEdit(true, !this.order.status)],
    });

    this.fetchSingleEntity();
    this.changeMode(FormModeEnum.View);
  }

  onTableActionAdd() {
    this.fetchSingleEntity();
    this.changeMode(FormModeEnum.Add);
  }

  fetchSingleEntity() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSPRO_PRO,
          FormName.PregledProgama,
          EndpointTypes.SingleEntity,
          '',
          this.order.Id
        )
        .subscribe(data => {
          this._spinner.hide();
          this.fieldStructure = new FieldStructure(data.Settings, 'header');
          this.settingsTableDetails = new TableSettings(
            data.Settings.details[0],
            'table'
          );
          if (this.order.Id) {
            this.orderListDetails = [...data.ServiceData[0].MestaTroska];
            this.orderListDetails.forEach(x => {
              x.Naziv = x.Id;
            });
            this.setRbr(this.orderListDetails);
          } else {
            this.orderListDetails = [];
          }

          this.setInfobar(true, 'Marina Milenkovic', this.order.DatumIzmene);
          this.showDetails = true;
          if (this.order.Id) {
            this.onViewModeWithParams(
              data.Privilegije.includes('MSPRO_PRO_CREATE'),
              data.Privilegije.includes('MSPRO_PRO_DELETE'),
              data.Privilegije.includes('MSPRO_PRO_UPDATE')
            );
          }
        })
    );
  }

  notyMestoTroskaDuplikatError() {
    this._notificationService.notyError('Mesta troška moraju biti različita!');
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    super.onTableActionFilter(event);
  }

  onCancel() {
    this.fetchSingleEntity();
    this.changeMode(FormModeEnum.View);
  }

  onDetailsEditCancel(event) {
    if (this.mestoTroskaList.some(a => a.Id === event.document.Id)) {
      this.copyProperties(
        event.document,
        this.mestoTroskaList.filter(a => a.Id === event.document.Id)[0]
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/odrzavanje-programa/odrzavanje-programa.component.ts